package com.milta.feature.spreadsheetimport.data.remote.dto

import com.milta.feature.spreadsheetimport.domain.entity.ImportedDeliveryRow
import com.milta.feature.spreadsheetimport.domain.entity.SpreadsheetImportResult
import kotlinx.serialization.Serializable

/** Mirrors the backend `SpreadsheetImportResultDto` (POST /api/v1/spreadsheet-imports, contrat validé MIL-27). */
@Serializable
data class SpreadsheetImportResultDto(
    val totalCount: Int,
    val incompleteCount: Int,
    val isStructuredFormat: Boolean,
    val deliveries: List<ImportedDeliveryRowDto>,
)

/** Mirrors the backend `ImportedDeliveryRow` entity — one row read off the uploaded Excel/CSV file. */
@Serializable
data class ImportedDeliveryRowDto(
    val recipientName: String? = null,
    val address: String? = null,
    val phoneNumber: String? = null,
    val deadlineTime: String? = null,
    val hasMissingFields: Boolean,
)

fun SpreadsheetImportResultDto.toDomain() = SpreadsheetImportResult(
    totalCount = totalCount,
    incompleteCount = incompleteCount,
    isStructuredFormat = isStructuredFormat,
    deliveries = deliveries.map { it.toDomain() },
)

fun ImportedDeliveryRowDto.toDomain() = ImportedDeliveryRow(
    recipientName = recipientName,
    address = address,
    phoneNumber = phoneNumber,
    deadlineTime = deadlineTime,
    hasMissingFields = hasMissingFields,
)
